import { jsxs as o, jsx as i } from "react/jsx-runtime";
import { RocheUILoadingIcon as n } from "../loading-icon/roche-loading-icon.js";
import r from "./roche-loading-spinner.module.scss.js";
const l = ({ loadingText: e }) => /* @__PURE__ */ o("div", { className: r["loading-spinner"], children: [
  /* @__PURE__ */ i(n, {}),
  /* @__PURE__ */ i("div", { className: r["loading-spinner__text"], "aria-live": "polite", "aria-busy": "true", children: e })
] });
export {
  l as RocheUILoadingSpinner
};
